var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngularLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2500 676.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b52e31;}.cls-2{fill:#e23237;}.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "angular-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M735.35,502V194.34H774.9l188,247.56V194.34h37.6V502H960.94l-188-250V502Zm571.29-12.21a228.3,228.3,0,0,1-80.08,14.16q-167,0-167-160.16,0-151.61,161.13-151.86c30.76,0,59.57,4.39,85.94,12.7v34.18a223.48,223.48,0,0,0-81.54-15.14c-84,0-126,40-126,119.14,0,85.45,41.5,127.93,124,127.93,13.18,0,27.83-2,43.95-5.37v-103h39.55V489.75Zm63.48-106.45v-189h39.55v189c0,59.08,29.3,88.87,88.38,88.87,58.59,0,88.38-29.79,88.38-88.87v-189H1626v189c0,80.57-42.48,121.09-127.93,121.09S1370.12,463.87,1370.12,383.3Zm366.21-189V469.73h161.13V502H1696.78V194.34ZM1954.59,502h-41.5l152.83-348.14L2218.75,502H2174.8l-39.55-96.68H2033.69L2044.43,373h77.64l-57.62-139.16L1954.59,502Zm306.64,0V194.34h131.35c58.59,0,87.89,24.41,87.89,73.73,0,40-28.81,69.82-85.94,88.87L2500,502h-52.25L2350.1,363.77V337.89c58.59-9.28,88.38-31.74,88.38-67.87,0-28.32-16.11-42.48-48.83-42.48h-87.89V502Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,112.3,314.94,0,638.18,110.35l-52.25,416.5-271,149.9L48.34,528.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M638.18,110.35,314.94,0V676.76l271-149.9,52.25-416.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.43,79.1,119.14,515.62l73.24-1.46,39.55-98.63H407.23l43,99.61L520,516.6,315.43,79.1Zm.49,140.14,66.41,138.67H257.81Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngularLogo);
export default __webpack_public_path__ + "static/media/angular-logo.303226e17701dca7573192bfef2d78f7.svg";
export { ForwardRef as ReactComponent };